import { v4 } from "uuid";

export class BaseUUID
{
    private static SIZE = 20;
    static isValid(id: any): boolean
    {
        let value = (id ?? "") + "";
        if (value.length != BaseUUID.SIZE)
            return false;
        let parts = id.split("@")[0].split("-");
        if (parts.length < 2)
            return false;
        return /^[a-z][a-z][a-z]$/.test(parts[0]);
    }
    static isValidShort(id: string, short: string): boolean
    {
        if (BaseUUID.isValid(id))
            return BaseUUID.getShort(id) === short;
        return false;
    }
    static getShort(id: string)
    {
        let parts = (id ?? "").split("@")[0].split("-");
        let ans = [];
        for (let index = 0; index < parts.length - 1; index++)
        {
            const part = parts[index];
            if (/^[a-z][a-z][a-z]$/.test(part))
                ans.push(part);
            else
                break;
        }
        return ans.join("-");
    }
    short: string;
    constructor(short: string)
    {
        this.short = short;
    }
    static uuid(lenght: number = 16): string
    {
        return v4().replace(/-/g, '').substring(0, lenght);
    }
    static isChild(id: string): boolean
    {
        let index = id.indexOf("@")
        return index != -1;
    }
    static changeToChild(owner_id: string, name: string): string
    {
        let index = owner_id.indexOf("@")
        if (index != -1)
            return owner_id.substring(0, index + 1) + name.substring(0, BaseUUID.SIZE - index - 1).padStart(BaseUUID.SIZE - index - 1, '-');
        return "";
    }
    new()
    {
        let ans = this.short + "-" + BaseUUID.uuid();
        return ans.substring(0, BaseUUID.SIZE);
    }
};